import React from 'react';

const DownloadIcon = ({ icon, ...restProps }: any) => (
  <span {...restProps}>
    <img src={icon} alt="" />
  </span>
);

export default DownloadIcon;
